import React from "react";

const StaffAppointmentInfo = () => {
  return <div>StaffAppointmentInfo</div>;
};

export default StaffAppointmentInfo;
